import request from '@/utils/request'

// 查询待提现信息
export function getWithdrawalList(params) {
  return request({
    url: '/user/admin/enterprise/job/queryReward',
    method: 'GET',
    params,
  })
}

// 新增奖励
export function getWithdrawalDetail(params) {
  return request({
    url: '/user/admin/enterprise/job/queryRewardDetail',
    method: 'GET',
    params,
  })
}
